import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../core/Error.js";
import { setDeepValue as t } from "../../core/object.js";
import { parse as r } from "./parser.js";
import { isEffectFunctions as s } from "./utils.js";

function n(e, t, r) {
  try {
    return c(e);
  } catch (n) {
    var s;
    null == r || null == (s = r.messages) || s.push(n);
  }

  return null;
}

function a(e, r, s, n) {
  try {
    var _n = o(e);

    t(s, _n, r);
  } catch (a) {
    n.messages && n.messages.push(a);
  }
}

function o(e) {
  var t = r(e);
  return t ? s(t) ? t.map(function (e) {
    return e.toJSON();
  }) : t.map(function (_ref) {
    var e = _ref.scale,
        t = _ref.effects;
    return {
      scale: e,
      value: t.map(function (e) {
        return e.toJSON();
      })
    };
  }) : null;
}

function c(e) {
  if (!e || 0 === e.length) return null;

  if (u(e)) {
    var _t = [];

    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _r = _step.value;

        _t.push({
          scale: _r.scale,
          value: f(_r.value)
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return _t;
  }

  return f(e);
}

function u(e) {
  var t = e[0];
  return !!t && "scale" in t;
}

function f(e) {
  if (!e || !e.length) return "";
  var t = [];

  var _iterator2 = _createForOfIteratorHelper(e),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _s = _step2.value;
      var _e = [];

      switch (_s.type) {
        case "grayscale":
        case "sepia":
        case "saturate":
        case "invert":
        case "brightness":
        case "contrast":
        case "opacity":
          _e = [i(_s, "amount")];
          break;

        case "blur":
          _e = [i(_s, "radius", "pt")];
          break;

        case "hue-rotate":
          _e = [i(_s, "angle", "deg")];
          break;

        case "drop-shadow":
          _e = [i(_s, "xoffset", "pt"), i(_s, "yoffset", "pt"), i(_s, "blurRadius", "pt"), l(_s, "color")];
          break;

        case "bloom":
          _e = [i(_s, "strength"), i(_s, "radius", "pt"), i(_s, "threshold")];
      }

      var _n2 = "".concat(_s.type, "(").concat(_e.filter(Boolean).join(" "), ")");

      r(_n2), t.push(_n2);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return t.join(" ");
}

function i(t, r, s) {
  if (null == t[r]) throw new e("effect:missing-parameter", "Missing parameter '".concat(r, "' in ").concat(t.type, " effect"), {
    effect: t
  });
  return s ? t[r] + s : "" + t[r];
}

function l(t, r) {
  if (null == t[r]) throw new e("effect:missing-parameter", "Missing parameter '".concat(r, "' in ").concat(t.type, " effect"), {
    effect: t
  });
  var s = t[r];
  return "rgba(".concat(s[0] || 0, ", ").concat(s[1] || 0, ", ").concat(s[2] || 0, ", ").concat(s[3] / 255 || 0, ")");
}

export { f as effectFunctionsFromJSON, c as fromJSON, n as read, o as toJSON, a as write };